<script>
import {
  iButton,
  iFeaturedIcon,
  iFeaturedIconTypes,
  iFeaturedIconSizes,
} from '@inscribe/signal';

export default {
  components: { iButton, iFeaturedIcon },
  props: {
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    buttonText: {
      type: String,
      default: null,
    },
  },
  data() {
    return { iFeaturedIcon, iFeaturedIconSizes, iFeaturedIconTypes };
  },
  methods: {
    onClick() {
      this.$emit('on-button-click');
    },
  },
};
</script>

<template>
  <div
    class="decision-engine-empty-page d-flex flex-column align-items-center justify-content-center i-radius-3xl i-p-11"
  >
    <div class="content d-flex flex-column align-items-center i-gap-8">
      <i-featured-icon
        :size="iFeaturedIconSizes.XXXL"
        :symbol="icon"
        :type="iFeaturedIconTypes.PRIMARY"
      ></i-featured-icon>
      <div class="text d-flex flex-column align-items-center i-gap-2">
        <div class="title i-text-neutral-120 i-text-heading-5">{{ title }}</div>
        <div class="subtitle i-text-neutral-110 i-text-body-2">
          {{ subtitle }}
        </div>
      </div>
      <i-button
        v-if="buttonText"
        :text="buttonText"
        size="md"
        @button-click="onClick"
      ></i-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.decision-engine-empty-page {
  border: 1px solid $light-neutral-60;
}
</style>
